export default {
    API_ENDPOINT:"https://obscure-castle-68689.herokuapp.com",
    TOKEN_KEY: process.env.REACT_APP_API_KEY || "blogful-client-auth-token",
  };
  